import React from "react";

export const ThreeDots: React.FC = () => (
  <span className="inline-flex ml-1 text-xl leading-none gap-0.5 text-white">
    <span className="animate-bounce">•</span>
    <span className="animate-bounce [animation-delay:0.15s]">•</span>
    <span className="animate-bounce [animation-delay:0.3s]">•</span>
  </span>
);

export default ThreeDots;
